import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { userReducer } from './reducers/userReducer';

import { cartReducer } from '../state/Cart/Reducer'; 
import { CustommerProductReducer } from '../state/Product/Reducer';

// Kết hợp các reducer
const rootReducer = combineReducers({
  cart: cartReducer,
  products: CustommerProductReducer,
  user: userReducer,
});

// Middleware
const middleware = [thunk];

// Tạo Redux Store
const store = createStore(
  rootReducer,
  applyMiddleware(...middleware)  // Không dùng redux-devtools-extension
);

export default store;
